(() => {
  const simpleTags = new Set(['STRONG', 'B', 'EM', 'I', 'BR']);
  const labelPattern = /^([^:\n]{2,64}):\s+(.+)$/;

  function appendLine(parent, line) {
    const match = line.match(labelPattern);
    const isLabel = match && !/^(https?|ftp)$/i.test(match[1]);
    if (isLabel) {
      let list = parent.lastElementChild;
      if (!list || list.tagName !== 'UL') {
        list = document.createElement('ul');
        parent.append(list);
      }
      const item = document.createElement('li');
      const label = document.createElement('strong');
      label.textContent = `${match[1]}:`;
      item.append(label, document.createTextNode(` ${match[2]}`));
      list.append(item);
    } else {
      const paragraph = document.createElement('p');
      paragraph.textContent = line;
      parent.append(paragraph);
    }
  }

  function formatDescription(root) {
    if (!root) return;
    // Only rewrite simple text. Rich HTML, images, links and existing lists stay intact.
    if ([...root.children].every((node) => node.tagName === 'BR')) {
      const text = root.innerHTML.replace(/<br\s*\/?\s*>/gi, '\n');
      const decoder = document.createElement('textarea');
      decoder.innerHTML = text;
      const fragment = document.createDocumentFragment();
      decoder.value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean)
        .forEach((line) => appendLine(fragment, line));
      root.replaceChildren(fragment);
    } else {
      [...root.children].forEach((paragraph) => {
        if (paragraph.tagName !== 'P' || [...paragraph.querySelectorAll('*')].some((node) => !simpleTags.has(node.tagName))) return;
        const copy = paragraph.cloneNode(true);
        copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
        const lines = copy.textContent.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
        if (!lines.length || !lines.every((line) => labelPattern.test(line))) return;
        const fragment = document.createDocumentFragment();
        lines.forEach((line) => appendLine(fragment, line));
        paragraph.replaceWith(fragment);
      });
    }
    [...root.children].forEach((node) => {
      let next = node.nextSibling;
      while (next && next.nodeType === Node.TEXT_NODE && !next.textContent.trim()) next = next.nextSibling;
      if (node.tagName === 'UL' && next?.nodeName === 'UL') {
        next.prepend(...node.childNodes);
        node.remove();
      }
    });
  }

  function extractPolicy(section) {
    const source = section.querySelector('[data-hc-policy-source]');
    const target = section.querySelector('[data-hc-policy-excerpt]');
    if (!source || !target) return;
    const content = source.content.cloneNode(true);
    content.querySelectorAll('script, style, link, iframe, form').forEach((node) => node.remove());
    // Shopify policies can use either heading elements or bold standalone paragraphs.
    content.querySelectorAll('p').forEach((paragraph) => {
      const child = paragraph.firstElementChild;
      if (paragraph.children.length === 1 && child && /^(STRONG|B)$/.test(child.tagName)
          && paragraph.textContent.trim() === child.textContent.trim() && paragraph.textContent.trim().length < 100) {
        const heading = document.createElement('h3');
        heading.textContent = paragraph.textContent;
        paragraph.replaceWith(heading);
      }
    });
    const headings = [...content.querySelectorAll('h1, h2, h3, h4, h5, h6')];
    const excerpt = document.createElement('ul');
    excerpt.className = 'hc-product-information__policy-summary';
    const findSection = (title) => {
      const heading = headings.find((node) => node.textContent.trim().toLowerCase() === title);
      if (!heading) return null;
      const range = document.createRange();
      range.setStartAfter(heading);
      const next = headings[headings.indexOf(heading) + 1];
      if (next) range.setEndBefore(next);
      else range.setEnd(content, content.childNodes.length);
      return range.cloneContents();
    };
    const addPoint = (label, body) => {
      if (!body || !body.textContent.trim()) return;
      const item = document.createElement('li');
      const title = document.createElement('strong');
      title.textContent = `${label}: `;
      item.append(title, body);
      excerpt.append(item);
    };
    const firstParagraph = (body, firstSentence = false) => {
      const paragraph = body?.querySelector('p');
      if (!paragraph) return null;
      if (firstSentence) {
        const sentence = paragraph.textContent.trim().match(/^[\s\S]*?[.!?](?=\s|$)/);
        return sentence ? document.createTextNode(sentence[0]) : null;
      }
      const fragment = document.createDocumentFragment();
      fragment.append(...paragraph.cloneNode(true).childNodes);
      return fragment;
    };

    if (section.dataset.hcPolicy === 'shipping') {
      addPoint('Processing', firstParagraph(findSection('order processing time')));
      const delivery = findSection('estimated delivery time');
      const timing = firstParagraph(delivery, true);
      const rows = [...(delivery?.querySelectorAll('tbody tr') || [])];
      if (timing && rows.length) {
        const fragment = document.createDocumentFragment();
        fragment.append(timing, document.createTextNode(' '));
        // Country and timing come from the policy table; omit the carrier inventory.
        const estimates = rows.map((row) => {
          const cells = row.querySelectorAll('td');
          return cells.length === 3 ? `${cells[0].textContent.trim()}: ${cells[2].textContent.trim()}` : '';
        }).filter(Boolean);
        const units = delivery.querySelector('thead')?.textContent.toLowerCase().includes('business days');
        if (estimates.length && units) {
          fragment.append(document.createTextNode(`${estimates.join('; ')} business days.`));
          addPoint('Delivery', fragment);
        }
      }
      addPoint('Shipping cost', firstParagraph(findSection('shipping rates'), true));
    } else {
      const exclusions = findSection('items that cannot be returned');
      const exceptionsText = firstParagraph(exclusions);
      const excludedItems = exclusions?.querySelector('ul');
      // Keep the eligibility exception together with every item it qualifies.
      if (exceptionsText && excludedItems) {
        const fragment = document.createDocumentFragment();
        fragment.append(exceptionsText, excludedItems.cloneNode(true));
        addPoint('Non-returnable items', fragment);
        addPoint('Return window', firstParagraph(findSection('return window')));
      }
      addPoint('Damaged or incorrect items', firstParagraph(findSection('damaged, defective, or incorrect items')));
    }
    if (!excerpt.childElementCount) return; // Unknown or missing policy: retain the full-policy link.
    excerpt.querySelectorAll('*').forEach((node) => {
      node.removeAttribute('id');
      node.removeAttribute('class');
      node.removeAttribute('style');
      [...node.attributes].filter((attribute) => attribute.name.startsWith('on')).forEach((attribute) => node.removeAttribute(attribute.name));
    });
    target.replaceChildren(excerpt);
    target.hidden = false;
  }

  function initialize(container = document) {
    container.querySelectorAll('[data-hc-product-information]').forEach((root) => {
      if (root.dataset.hcInformationReady) return;
      root.dataset.hcInformationReady = 'true';
      formatDescription(root.querySelector('[data-hc-design-description]'));
      root.querySelectorAll('[data-hc-policy]').forEach(extractPolicy);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
